"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.removeToast = exports.addNewToast = void 0;
const ActionTypes = require("../actionTypes/toast");
function generateHash() {
    function shuffle(a) {
        let j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return a;
    }
    const hash = Array.from({ length: 24 }, () => Math.floor(Math.random() * 9));
    return shuffle(hash).join('');
}
function addNewToast(title, message, type = 'NORMAL', onClickActions = [], uuid = generateHash(), timeout) {
    return {
        type: ActionTypes.ADD_NEW_TOAST,
        payload: {
            uuid,
            title,
            message,
            type,
            onClickActions,
            timeout
        }
    };
}
exports.addNewToast = addNewToast;
function removeToast(uuid) {
    return {
        type: ActionTypes.REMOVE_TOAST,
        payload: uuid
    };
}
exports.removeToast = removeToast;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=toast.js.map